module.exports = __webpack_public_path__ + "static/media/logo.fdc2f759.png";